module.exports = __webpack_public_path__ + "media/vine_boom.0a1243a6.mp3";